import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { FORM_CUPO_MULTIPLE } from '../../../../config/forms'

function CuposAUtilizar (props) {
  const [cantidadAUtilizar, setCantidadAUtilizar] = useState(0)

  useEffect(() => {
    const { cupo, cuposCacheNominados } = props
    async function buscarCantidadesNominadas () {
      cuposCacheNominados.forEach((cupito) => {
        if (cupito.fechaDeEmision === cupo.fechaDeEmision &&
          cupito.cereal === cupo.claveCereal &&
          cupito.exportador === cupo.cuitExportador) {
          setCantidadAUtilizar((cantidadAUtilizar) => cantidadAUtilizar + cupito.cantidad)
        }
      })
    }
    setCantidadAUtilizar(0)
    buscarCantidadesNominadas()
  }, [props])

  return (
    <div>
      <h6>{cantidadAUtilizar}</h6>
    </div>
  )
}

const mapStateToProps = (state) => ({
  cuposCacheNominados: state.cupos.cuposCacheNominados
})

const mapActionsToProps = {
}
const withRedux = connect(mapStateToProps, mapActionsToProps)

export default withRedux(reduxForm({
  form: FORM_CUPO_MULTIPLE
})(CuposAUtilizar))
